import { Link } from "react-router-dom";

// Single transparent-background brand asset (compass icon + "PipeGuide" wordmark stacked).
// Transparent PNG so it sits cleanly on any surface without a tile background.
const LOGO_SRC = "https://customer-assets.emergentagent.com/job_deal-readiness/artifacts/wjetx0cs_Pipeguide%20Logo%204.PNG";

/**
 * PipeGuide brand logo — horizontal navbar lockup.
 * Crops just the compass icon from the square stacked source asset so the
 * built-in "PipeGuide" wordmark below the icon doesn't get clipped at small
 * sizes. The wordmark is rendered alongside in Bricolage Grotesque for crisp
 * legibility regardless of size.
 */
export const Logo = ({ variant = "light" }) => {
    const isDark = variant === "dark";
    const textColor = isDark ? "text-white" : "text-zinc-900";

    return (
        <Link
            to="/"
            data-testid="site-logo"
            aria-label="PipeGuide — home"
            className="inline-flex items-center gap-2.5 group"
        >
            {/* Icon-only crop: shows the compass at the top of the stacked source.
                Transparent backing means the icon sits naturally on light or dark surfaces. */}
            <div
                className="h-10 w-10 relative overflow-hidden flex-shrink-0"
                aria-hidden
            >
                <img
                    src={LOGO_SRC}
                    alt=""
                    className="absolute block transition-transform group-hover:scale-105"
                    style={{
                        // Source 541×542: compass icon at rows 30–390, blank gap 400–435,
                        // wordmark 440–515. We oversize to 60×60 and shift up so the 40×40
                        // tile shows only the compass (rows ~27 to ~387).
                        width: "60px",
                        height: "60px",
                        left: "-10px",
                        top: "-3px",
                        maxWidth: "none",
                    }}
                />
            </div>
            <span className={`font-display text-xl font-bold tracking-tight ${textColor}`}>
                PipeGuide
            </span>
        </Link>
    );
};

export default Logo;
